import clock_skew from "../../../../src/sv/images/clock_skew.svg";
import clock_ex_1 from "../../../../src/sv/images/clock_skew_basic_op_edit.png";
import * as React from 'react';
export default {
  clock_skew,
  clock_ex_1,
  React
};